document.addEventListener('DOMContentLoaded', () => {
    if ($(window).width() > 1101) {
      $(window).scroll(function () {
        if ($(window).scrollTop() + ($(window).height() * 2) / 3 > $('.aph320-full-image').offset().top) {
          $('.aph320-full-image').addClass('animate-text');
        } else {
          $('.aph320-full-image').removeClass('animate-text');
        }
      });
    }
  });